import { render, staticRenderFns } from "./ReauthenticationDialog.vue?vue&type=template&id=3c36f8bd"
import script from "./ReauthenticationDialog.vue?vue&type=script&lang=js"
export * from "./ReauthenticationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports